import {computed, ref} from 'vue';
import orderBy from 'lodash-es/orderBy';
import {useAsyncData} from '#imports';
import {useApis} from '~/composables';

export function useCompanyClientsForOnBehalfOfSearch(clientCompanyId: string) {
    const {advancedSearchAuthenticatedApi} = useApis();

    const search = ref('');
    const {
        data: clients,
        status,
        error,
    } = useAsyncData(() => advancedSearchAuthenticatedApi.listCompanyClientsForOnBehalfOf({clientCompanyId}), {
        deep: true,
    });

    const fetching = computed(() => status.value === 'pending');

    const results = computed(() => {
        if (fetching.value || error.value) {
            return [];
        }

        const filter = new RegExp(search.value ?? '', 'i');

        return orderBy(
            clients.value!.filter((client) => client.name.match(filter)),
            'name',
        );
    });

    return {search, results, fetching, error};
}
